export default 'https://api.giztix.com';
